module.exports = __webpack_public_path__ + "static/img/game1_bg1.374e58ff.png";